import { z } from "zod";

import { AuthServicePorts } from "../../../model";

import { UserRoleEntity } from "~/entities/user-role/@x/auth";

const zSourceSchema = AuthServicePorts.ProviderIos.Common.zOut;

const zOutSchema = zSourceSchema
  .pick({
    id: true,
  })
  .extend({
    email: zSourceSchema.shape.email.nullable(),
    phoneNumber: zSourceSchema.shape.phone.nullable(),
    userName: zSourceSchema.shape.username.nullable(),
    firstName: zSourceSchema.shape.firstName.nullable(),
    lastName: zSourceSchema.shape.lastName.nullable(),
    roles: z.array(
      UserRoleEntity.zSchema.extend({
        name: UserRoleEntity.zSchema.shape.name.nullable(),
        description: UserRoleEntity.zSchema.shape.description.nullable(),
      }),
    ),
  });
type OutSchema = z.infer<typeof zOutSchema>;

export { zOutSchema };
export type { OutSchema };
